export default __webpack_public_path__ + "static/media/fileWithMagnifyingGlass.c1a0ae93.png";